import { useContext, useCallback } from 'react';
import { useSiteInfo } from '@contexts/SiteInfoContext';
import { getUMInfoWithDesktopAndMobile } from '@utils/LoginProcess/requests';
import { LoginDataContext } from '@contexts/LoginDataContext';
import { UMDataContext } from '@contexts/UMDataContext';

const useCurrentPlatformUMStatus = () => {
    const [umDataState, umDataDispatch] = useContext(UMDataContext);
    const [loginData] = useContext(LoginDataContext);
    const { siteId, clientApiUrl } = useSiteInfo();

    const fetchCurrentPlatUMData = useCallback(async (switchToPlatform = null) => {
        try {
            const targetPlatform = switchToPlatform || loginData.platform;
            const response = await getUMInfoWithDesktopAndMobile(clientApiUrl, siteId);
            const currentPlatformUMData = response[targetPlatform];

            if (currentPlatformUMData.isUnderMaintenance) {
                umDataDispatch({
                    type: 'UPDATE_UM_DATA',
                    payload: { umPlatform: targetPlatform, ...currentPlatformUMData },
                });
            }
            return currentPlatformUMData.isUnderMaintenance;
        } catch (err) {
            console.error(err);
        }
    }, [loginData, siteId, umDataDispatch]);
    return { fetchCurrentPlatUMData };
};

export default useCurrentPlatformUMStatus;
